import { createGlobalStyle } from 'styled-components';
import backgroundImage from './assets/5.webp'; // Update the path accordingly

const GlobalStyle = createGlobalStyle`
  body, html, #root {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  #root {
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
  }
`;

export default GlobalStyle;
